export class StepData {
    constructor(p_stepId) {
        this.stepId = p_stepId;
        this.stateId = [];
        this.properties = [];
    }
}